import request from '@/plugin/axios'

export function saveMemberLevel (data) {
  return request({
    url: '/api/admin/saveMemberLevel',
    method: 'post',
    data: data
  })
}
export function updateMemberLevel (data) {
  return request({
    url: '/api/admin/updateMemberLevel',
    method: 'post',
    data: data
  })
}

export function queryMemberLevelPage (data) {
  return request({
    url: '/api/admin/queryMemberLevelPage',
    method: 'get',
    params: data
  })
}
export function queryMemberLevelDetail (data) {
  return request({
    url: '/api/admin/queryMemberLevelDetail',
    method: 'get',
    params: data
  })
}
export function queryMealOrderPage (data) {
  return request({
    url: '/api/admin/queryMealOrderPage',
    method: 'get',
    params: data
  })
}
export function updateMemberLevelStation (data) {
  return request({
    url: '/api/admin/updateMemberLevelStation',
    method: 'post',
    data: data
  })
}
